var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 12.1663V13.833C1.33325 14.275 1.50885 14.699 1.82141 15.0115C2.13397 15.3241 2.55789 15.4997 2.99992 15.4997H12.9999C13.4419 15.4997 13.8659 15.3241 14.1784 15.0115C14.491 14.699 14.6666 14.275 14.6666 13.833V12.1663M3.83325 7.16634L7.99992 11.333M7.99992 11.333L12.1666 7.16634M7.99992 11.333V1.33301",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.27283243bcca118f8fdb1b5c2b0aa684.svg";
export { ForwardRef as ReactComponent };